module.exports = __webpack_public_path__ + "static/media/pptx.a803344d.png";